<template>
  <div>
    <vs-tabs position="left" alignment="left">
      <vs-tab label="Рассылка">
        <div class="pl-6 pt-2">
          <DeliveryTab
            @changeStatus="onChangeStatus"
            :task="task"
            :analytics="analytics"
            :receiversCount="receiversCount"
          />
        </div>
      </vs-tab>
      <vs-tab label="Получатели">
        <div class="pl-6 pt-2">
          <ReceiversTab
            @changeTask="onChangeTask"
            :task="task"
          />
        </div>
      </vs-tab>
    </vs-tabs>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import BulkDeliveryService from '@/api/http/models/bulkDelivery/BulkDeliveryService'
import DeliveryTab from '@/pages/bulk-delivery/components/DeliveryTab'
import ReceiversTab from '@/pages/bulk-delivery/components/ReceiversTab'

export default {
  components: {
    DeliveryTab,
    ReceiversTab
  },
  data () {
    return {
      task: {},
      analytics: {}
    }
  },
  computed: {
    ...mapGetters(['authUserCompany']),
    ...mapState('Receivers', {
      receiversCount: state => state.items.length
    })
  },
  async created () {
    const [taskResponse, analyticsResponse] = await Promise.all([
      BulkDeliveryService.getTask(this.authUserCompany.slug, this.$route.params.slug).catch((e) => console.error(e)),
      BulkDeliveryService.getReport(this.authUserCompany.slug, this.$route.params.slug).catch((e) => console.error(e)),
      this.fetchItems(this.$route.params.slug).catch((e) => console.error(e))
    ])

    this.task = taskResponse && taskResponse.data
    this.analytics = analyticsResponse && analyticsResponse.data
  },
  methods: {
    ...mapActions('Receivers', ['fetchItems']),
    onChangeStatus (status) {
      this.task = { ...this.task, status }
    },
    onChangeTask (task) {
      this.task = task
    }
  }
}
</script>
